var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-import" },
    [
      _c("section", { staticClass: "mb-4" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col-12 mb-2" }, [
                _c("b", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("message.autopickcolumn")) +
                      "\n            "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", gap: "20px" } },
                  [
                    _c("BaseRadioRich", {
                      attrs: { val: 1, label: _vm.$t("message.yes") },
                      model: {
                        value: _vm.autoPickColumn,
                        callback: function($$v) {
                          _vm.autoPickColumn = $$v
                        },
                        expression: "autoPickColumn"
                      }
                    }),
                    _vm._v(" "),
                    _c("BaseRadioRich", {
                      attrs: { val: 0, label: _vm.$t("message.no") },
                      model: {
                        value: _vm.autoPickColumn,
                        callback: function($$v) {
                          _vm.autoPickColumn = $$v
                        },
                        expression: "autoPickColumn"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "file has-name is-fullwidth" }, [
              _c("label", { staticClass: "file-label" }, [
                _c("input", {
                  ref: "file",
                  staticClass: "file-input",
                  attrs: { type: "file" },
                  on: { change: _vm.handleFileUpload }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "file-cta" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", { staticClass: "file-label" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.choosefile")) +
                        "\n              "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "file-name" }, [
                  _c("span", { staticClass: "text-grey" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.inputFileHelperText) +
                        "\n              "
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.isUploadFailed
        ? [
            _c("section", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("span", { staticClass: "text-danger" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.invalidimporttemplate")) +
                        "\n          "
                    )
                  ])
                ])
              ])
            ])
          ]
        : [
            _c("section", { staticClass: "mb-2" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("p", { staticClass: "mb-1" }, [
                    _c("b", [
                      _vm._v(_vm._s(_vm.$t("message.importproductswith3steps")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.importproductstep1")) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.importproductstep2")) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.$t("message.importproductstep3")))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "mb-2" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("p", { staticClass: "mb-1" }, [
                    _c("b", [
                      _vm._v(_vm._s(_vm.$t("message.downloadexampleexcelfile")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: _vm.templateLink.source, download: "" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.templateLink.name) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("section", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("p", { staticClass: "mb-1" }, [
                    _c("b", [_vm._v(_vm._s(_vm.$t("message.note")))])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.noteimportexcelfile")) +
                        "\n          "
                    )
                  ])
                ])
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "file-icon" }, [
      _c("i", { staticClass: "fas fa-upload" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6d01062", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6d01062","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseFormImportExcel.vue
// module id = null
// module chunks = 